<template>
    <div>
        <nav-breadcrumb :menu="[{label :'客户贷款详情'}]"/>
        <el-row>
            <el-col class="grid-content bg-purple">
                <el-tabs v-model="tabName">
                    <template>
                        <el-tab-pane label="贷款信息" name="CustomerSummary">
                            <el-row style="margin:10px 20px 0 20px;">
                                <el-col :span="12">
                                    <div class="Htitle-text">贷款信息</div>
                                </el-col>
                                <el-col :span="12">
                                    <div style="text-align: right;padding-top: 10px">
                                        <el-button type="primary" size="mini" @click="jinjian">进件</el-button>
                                        <el-button type="primary" size="mini" @click="yongkuan" v-if="listData.count==1">用款</el-button>
                                        <el-button type="primary" size="mini" @click="shisuan" v-if="financingDetail.fi__transactionStatus=='Processing'">还款试算</el-button>
                                    </div>

                                </el-col>
                            </el-row>
                            <el-form label-width="170px" class="xzformitemmb">
                                <el-row>
                                    <panel border>
                                        <el-col :span="12">
                                            <el-form-item label="贷款编号 ：">
                                                {{financingDetail.fi__transactionNo}}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12" v-if="financingDetail.dfi__withEquitySwap=='N'">
                                            <el-form-item label="贷款状态：">
                                                {{'Financing_'+ financingDetail.fi__transactionStatus|Status2CN}}

                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12" v-if="financingDetail.dfi__withEquitySwap=='Y'">
                                            <el-form-item label="贷款状态：">
                                                {{'Financing_'+ financingDetail.fi__transactionStatus|Status2CN}}<span style="color: red">({{financingDetail.dfi__equitySwap.transactionStatus|Status2CN}})</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="客户名称：">
                                                {{financingDetail.fi__customerName}}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="客户手机号：">
                                                {{financingDetail.ba__customerContactNo}}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="渠道商：">
                                                {{financingDetail.d__dealerName}}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">

                                            <el-form-item label="贷款金额：">
                                                {{financingDetail.fi__totalAmount|formatMoney}} 元
                                            </el-form-item>
                                            <el-form-item label="贷款申请日期：">
                                                {{financingDetail.fi__transactionDate|moment('YYYY-MM-DD')}}
                                            </el-form-item>
                                            <el-form-item label="贷款开始日期：">
                                                {{financingDetail.fi__startDate|moment('YYYY-MM-DD')}}
                                            </el-form-item>
                                            <el-form-item label="贷款合同利率：">
                                                {{financingDetail.fi__interestRate}}% （{{financingDetail.fi__interestType|Status2CN}}）
                                            </el-form-item>
                                            <el-form-item label="留存收益率：">
                                                {{financingDetail.dfi__interestRate}}% （{{financingDetail.dfi__interestType|Status2CN}}）
                                            </el-form-item>
                                            <!--                <el-form-item label="利息收取节点：">
                                            {{financingDetail.fi__interestPayTime}}
                                            </el-form-item>-->
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="贷款产品：">
                                                {{financingDetail.ct__productName}}
                                            </el-form-item>
                                            <el-form-item label="是否调整期限">
                                                &nbsp;<el-checkbox true-label="Y" false-label="N" v-model="financingDetail.fi__endDateFixed" disabled></el-checkbox>
                                            </el-form-item>
                                            <el-form-item label="贷款结束日期：">
                                                {{financingDetail.fi__endDate|moment('YYYY-MM-DD')}}
                                            </el-form-item>
                                            <!--                <el-form-item label="贷款比例：">
                                            {{financingDetail.ct__financingRatio}}%
                                            </el-form-item>-->

                                            <!--                <el-form-item label="费用收取节点：">
                                            {{financingDetail.fi__lendingFeePayTime}}
                                            </el-form-item>-->
                                            <el-form-item label="还款期数（月）：">
                                                {{financingDetail.fi__repaymentCount}}
                                                <el-button type="primary" size="mini" icon="el-icon-more" @click="viewRepayPlay">查看还款计划</el-button>
                                            </el-form-item>
                                            <el-form-item label="还款方式：">
                                                {{financingDetail.fi__repaymentFormula|Status2CN}}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="罚息复利率：">
                                                {{financingDetail.fi__penaltyInterestRate}}% （年利率）
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="贷款用途：">
                                                {{financingDetail.fi__intendedUse}}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="还款码">
                                                {{financingDetail.fi__repaymentCode}}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="收款账号：">
                                                {{financingDetail.cb__accountNo}}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="开户行：">
                                                {{financingDetail.cb__bank}}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="户名：">
                                                {{financingDetail.cb__accountName}}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="代理人：">
                                                {{financingDetail.fi__proxyPersonName}}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="放款账户：">
                                                {{financingDetail.pba__accountName}}-{{financingDetail.pba__branch}}-{{financingDetail.pba__accountNo}}
                                            </el-form-item>
                                        </el-col>
                                    </panel>
                                </el-row>
                            </el-form>
                            <panel label="房屋信息">
                                <panel :label="'抵押物'+(idx+1)"  v-for="(item, idx) in financingDetail.properties" :key="idx" >
                                    <form-build
                                        :form-data="item"
                                        :form-rules="financingRules"
                                        :form-columns="houseColumns"
                                        class="formTable"
                                    />
                                    <br/>
                                    <div class="zhenjianyyzz zhenjianyyzz2">
                                        <photo-browser v-model="item.doc__hisWarrant" type='image' label="他项权证"/>
                                    </div>
                                </panel>
                               <!-- <el-form  :model="financingDetail"  ref="formBuildName2" :rules="remarksRules" label-width="150px">
                                    <el-row :gutter="10" class="bg-purple xamhtrpg">
                                        <el-col :span="24">
                                            <el-form-item label="备注：" style="width: 60%"  >
                                                {{financingDetail.fi__remarks}}
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>-->
                            </panel>
                           <!-- <panel title="他项权证">
                                <photo-browser v-model="financingDetail.fidoc__hisWarrant" type='image' label=""/>
                            </panel>-->
                            <panel title="附件列表">
                                <files-data-table :files="financingDetail.files"></files-data-table>
                            </panel>
                            <panel >
                                <form-build
                                    :form-data.sync="approveDetail"
                                    :form-rules="financingRules"
                                    :form-columns="approveColumns"
                                    class="formTable"
                                />
                            </panel>

                            <el-dialog title="查看还款计划" :visible.sync="repaymentDialogVisible" width="90%">
                                <data-table :table-data="{data: planData}" :columns="columns" :is-pagination-show="false"></data-table>
                            </el-dialog>

                        </el-tab-pane>
                        <el-tab-pane label="放款还款" name="Pay">
                            <panel label="放款信息">
                                <el-form label-width="170px" class="xzformitemmb">
                                    <el-row>
                                        <panel title="" border>
                                            <el-col :span="12">
                                                <el-form-item label="流水号 ：">
                                                    {{financingDetail.pay__reference}}
                                                </el-form-item>
                                                <el-form-item label="放款方式 ：">
                                                    {{financingDetail.pay__channel|Status2CN}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="放款状态 ：">
                                                    {{"Pay_"+financingDetail.fi__transactionStatus|Status2CN}}
                                                </el-form-item>
                                                <el-form-item label="放款金额 ：">
                                                    {{financingDetail.pay__totalAmount|formatMoney}} 元
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="放款时间 ：">
                                                    {{(financingDetail.pay__payDate||{})|moment('YYYY-MM-DD')}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="放款人 ：">
                                                    {{financingDetail.pay__cashier == 'SYSTEM' ? '自动放款' : financingDetail.pay__cashier}}
                                                </el-form-item>
                                            </el-col>
                                            <!--         <el-col :span="24">
                                            <el-form-item label="放款账户 ：">
                                            {{financingDetail.pba__bank?financingDetail.pba__bank+'-':''+(financingDetail.pba__accountName?financingDetail.pba__accountName+"-":'')+financingDetail.pba__accountNo?financingDetail.pba__accountNo:''}}
                                            </el-form-item>
                                            </el-col>-->
                                            <el-col :span="24">
                                                <el-form-item label="收款账户 ：">
                                                    {{(financingDetail.pay__customerAccountBankName==null?'':financingDetail.pay__customerAccountBankName)+"-"+(financingDetail.pay__customerAccountName==null?'':financingDetail.pay__customerAccountName)+"-"+(financingDetail.pay__customerAccountNo==null?'':financingDetail.pay__customerAccountNo)}}
                                                </el-form-item>
                                            </el-col>
                                        </panel>
                                    </el-row>
                                </el-form>
                            </panel>
                            <panel title="还款信息" border>
                                <data-table
                                    :columns="RepayColumns"
                                    :table-data="{data:financingDetail.repayments.filter(item=>item.re__sequenceNo) }"
                                    :actions="actions"
                                    :is-pagination-show="false"
                                >
                                </data-table>
                            </panel>
                        </el-tab-pane>
                        <el-tab-pane label="共借人" name="borrower">
                            <panel v-for="(item, idx) in financingDetail.coborrowers" :key="idx">
                                <el-checkbox true-label="true" false-label="false" :label="'共借人'+(idx+1)" v-model="item.co__checked" disabled v-if="item.co__checked"></el-checkbox>
                                <panel class="zhengjianxinxi" v-if="item.co__checked">
                                    <form-build
                                        :form-data.sync="item"
                                        :form-rules="coRules"
                                        :form-columns="coColumns"
                                        class="formTable"
                                    />
                                </panel>
                                <panel class="zhengjianxinxi" v-if="item.co__checked">
                                    <photo-browser v-model="item.co__borrowerICFront" type='image' label="本人身份证正面"/>
                                    <photo-browser v-model="item.co__borrowerICBack" type='image' label="本人身份证反面" />
                                    <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="item.co__borrowerHukou1" :editable="false" ></file-upload>户口本</div>
                                </panel>
                            </panel>
                        </el-tab-pane>
                        <el-tab-pane label="关联账户" name="bank">
                            <data-table
                                :table-data="bankData"
                                :columns="bankColumns"
                                :actions="actions"
                                :is-pagination-show="false"
                            />
                        </el-tab-pane>
                    </template>
                </el-tabs>
            </el-col>
        </el-row>
        <div class="tr xzmt">
            <el-button @click="$router.go(-1)">返回</el-button>
        </div>
        <el-dialog title="" :visible.sync="jinjianDialogVisible" width="90%">
            <customer-view :application-id="financingDetail.fi__referenceId"></customer-view>
        </el-dialog>
        <el-dialog title="" :visible.sync="yongkuanDialogVisible" width="90%">
            <loan-approved-view :application-id="applicationId"></loan-approved-view>
        </el-dialog>
        <el-dialog title="" :visible.sync="shisuanDialogVisible" width="60%" >
            <panel border>
                <form-build :form-data="financingDetail" :form-columns="shisuanColumns" ></form-build>
            </panel>
            <el-button  type="primary" size="mini" @click="shisuan2" >试算</el-button>
            <panel :title="'第'+item.plan__sequenceNo+'期（最后还款日：'+ item.rex__expectedRepayDate+'）'" border v-for="(item, idx) in repayPlanList" :key="idx">
                <form-build :form-data="item" :form-columns="repayInfoColumns" v-if="item.rex__extendible == 'N'"></form-build>
                <form-build :form-data="item" :form-columns="repayInfoColumnsTwo" v-if="item.rex__extendible == 'Y'"></form-build>
            </panel>
            <div class="tr " style="padding-right:15px" v-if="repayPlanList.length>0">本次减免合计：{{freeAmount}}</div>
            <div class="tr " style="padding-right:15px" v-if="repayPlanList.length>0">本次应收总计：{{expectedTotalAmounts}}</div>
        </el-dialog>
        <el-dialog
            :visible.sync="dialogVisible"
            width="70%">
            <data-table
                :table-data="tableDataDetail"
                :columns="columnsDetail"
                :is-pagination-show="false"
            />
        </el-dialog>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import Status2CN from "../../filters/Status2CN";
    import {formatMoney} from "../../filters/CommonFilters";
    import moment from 'moment'
    import Panel from "../../components/Panel";
    import CustomerView from "./CustomerView";
    import LoanApprovedView from "./../fang/LoanApprovedView";
    export default {
        name: "CustomerFinancingDetail",
        components: {Panel,CustomerView,LoanApprovedView},
        data(){
            return {
                tableDataDetail:{},
                columnsDetail:[
                    {
                        label: '序号',
                        field: 'cl__index',
                    },
                    {
                        label: '期数',
                        field: 'dr__sequenceNo',
                    },
                    {
                        label: '实还日期',
                        field: 'cl__clearDate',
                        formatter: function (r,c,v) {
                            if(v)
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '还款金额',
                        field: 'cl__clearAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '备注',
                        field: 'cl.remarks'
                    },
                ],
                remarksRules:{},
                expectedTotalAmounts:0,
                repayPlanList:[],
                transferRepaymentDetail:{},
                editable:true,
                shisuanColumns:[
                    {
                        label: '贷款编号',
                        field: 'fi__contractNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'fi__customerName'
                    },
                    {
                        label: '还款日期',
                        field: 't__repayDate',
                        component: 'el-date-picker',
                        valueFormat: 'yyyy-MM-dd',
                        span:24
                    },

                ],
                repayInfoColumns: [
                    {
                        label: '应还款日',
                        field: 'rex__expectedRepayDate',
                        span:24,
                    },
                    {
                        label: '应还本金',
                        field: 'rex__expectedPrincipalAmount',
                        span:24,
                        formatter: (r,v) => {
                            return (Number(v)||0).toFixed(2)
                        }
                    },
                    {
                        label: '应还利息',
                        field: 'rex__expectedInterestAmount',
                        span:24,
                        formatter: (r,v) => {
                            return (Number(v)||0).toFixed(2)
                        }
                    },
                    {
                        label: '逾期天数',
                        field: 'rex__overdueDays',
                        span:24,
                    },
                    {
                        label: '应收复利',
                        field: 'rex__expectedCompoundInterest',
                        span:24,
                        component: (r,v)=> {
                            let disabled = !this.editable
                            return {
                                template: `<div>{{'${(v||0)}'|formatMoney}}<el-checkbox type="radio" :disabled ="disabled" v-model="r.rex__waiveCompoundInterest" true-label="Y" false-label="N"  v-if="v>0">免除</el-checkbox></div>`,
                                data() {
                                    return {
                                        r,
                                        v,
                                        disabled
                                    }
                                }
                            }
                        }
                    },
                    {
                        label: '应还罚息',
                        field: 'rex__expectedOverdueFine',
                        span:24,
                        component: (r,v)=> {
                            let disabled = !this.editable
                            return {
                                template: `<div>{{'${(v||0)}'|formatMoney}}<el-checkbox type="radio" :disabled ="disabled"  v-model="r.rex__waiveOverdueFine" true-label="Y" false-label="N"  v-if="v>0">免除</el-checkbox></div>`,
                                data() {
                                    return {
                                        r,
                                        v,
                                        disabled
                                    }
                                }
                            }
                        }
                    },
                    {
                        label: '应收合计',
                        field: 'expectedTotalAmount',
                        formatter: (r,v) => {
                            return (Number(v)||0).toFixed(2)
                        },
                        span: 24
                    },
                ],
                repayInfoColumnsTwo: [
                    {
                        label: '应还款日',
                        field: 'rex__expectedRepayDate',
                        span:24,
                    },
                    {
                        label: '应还本金',
                        field: 'rex__expectedPrincipalAmount',
                        span:24,
                        formatter: (r,v) => {
                            return (Number(v)||0).toFixed(2)
                        }
                    },
                    {
                        label: '应还利息',
                        field: 'rex__expectedInterestAmount',
                        span:24,
                        formatter: (r,v) => {
                            return (Number(v)||0).toFixed(2)
                        }
                    },
                    {
                        label: '延期天数',
                        field: 'rex__extendingDays',
                        component: 'el-input',
                    //    disabled :!this.editable,
                        type: 'number',
                        props: {
                            step: 1
                        },
                        span:24
                    },
                    {
                        label: '延期利息',
                        field: 'rex__extendingInterestAmount',
                        span:24,
                        formatter: (r,v) => {

                            // this.$set(r, 'rex__extendingInterestAmount', extendingInterestAmount.toFixed(2))

                            // return  extendingInterestAmount.toFixed(2)
                            return (Number(v)||0).toFixed(2)
                        }
                    },
                    {
                        label: '应收复利',
                        field: 'rex__expectedCompoundInterest',
                        span:24,
                        component: (r,v)=> {
                            let disabled = !this.editable
                            return {
                                template: `<div>{{'${(v||0)}'|formatMoney}}<el-checkbox type="radio" :disabled ="disabled" v-model="r.rex__waiveCompoundInterest" true-label="Y" false-label="N"  v-if="v>0">免除</el-checkbox></div>`,
                                data() {
                                    return {
                                        r,
                                        v,
                                        disabled
                                    }
                                }
                            }
                        }
                    },
                    {
                        label: '应还罚息',
                        field: 'rex__expectedOverdueFine',
                        span:24,
                        component: (r,v)=> {
                            let disabled = !this.editable
                            return {
                                template: `<div>{{'${(v||0)}'|formatMoney}}<el-checkbox type="radio" :disabled ="disabled"  v-model="r.rex__waiveOverdueFine" true-label="Y" false-label="N"  v-if="v>0">免除</el-checkbox></div>`,
                                data() {
                                    return {
                                        r,
                                        v,
                                        disabled
                                    }
                                }
                            }
                        }
                    },
                    {
                        label: '应收合计',
                        field: 'expectedTotalAmount',
                        formatter: (r,v) => {
                            return (Number(v)||0).toFixed(2)
                        },
                        span: 24
                    },
                ],
                listData: {},
                applicationId:'',
                bankColumns: [
                    {
                        label: '账号',
                        field: 'cb__accountNo'
                    },

                    {
                        label: '户名',
                        field: 'cb__accountName'
                    },
                    {
                        label: '开户银行',
                        field: 'cb__bank'
                    },
                    {
                        label: '创建时间',
                        field: 'cb__createdDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD HH:mm:ss')
                        }
                    },
                ],
                actions: [],
                coRules:{

                },
                coColumns:[
                    {
                        label: '与借款人关系',
                        field: 'co__relationship',
                    },
                    {
                        label: '姓名',
                        field: 'co__borrowerName',
                    },
                    {
                        label: '身份证号码',
                        field: 'co__borrowerIC',
                    },
                    {
                        label: '手机号',
                        field: 'co__borrowerContactNo',
                    },
                    {
                        label: '住所地址',
                        field: 'co__borrowerAddress',
                        span:24
                    },
                ],
                repaymentDialogVisible:false,
                jinjianDialogVisible:false,
                yongkuanDialogVisible:false,
                shisuanDialogVisible:false,
                tabName: 'CustomerSummary',
                approveDetail:{},
                transactionId: this.$route.query['transactionId']||'',
                financingDetail :{
                    repayments:[],
                    coborrowers:[],
                },
                financingRules:{},
                customerOption:[],
                productOptions:[],
                approveColumns:[


                ],
                financingColumns:[
                    {
                        label: '贷款编号',
                        field: 'fi__transactionNo',

                    },
                    {
                        label: '贷款状态',
                        field: 'fi__transactionStatus',
                        formatter: function (c,v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '客户姓名',
                        field: 'ba__customerName',
                    },
                    {
                        label: '客户手机号',
                        field: 'ba__customerContactNo',

                    },
                    {
                        label: '贷款金额',
                        field: 'fi__totalAmount',
                        unit:'元',


                    },
                    {
                        label: '贷款产品',
                        field: 'p__productName',
                    },
                    {
                        label: '开始日期',
                        field: 'fi__startDate',

                    },
                    {
                        label: '结束日期',
                        field: 'fi__endDate',

                    },
                    {
                        label: '申请日期',
                        field: 'fi__transactionDate',

                    },
                    {
                        label: '贷款比例（%）',
                        field: 'ct__financingRatio',


                    },
                    {
                        label: '贷款利率（%）',
                        field: 'fi__interestRate',


                    },
                    {
                        label: '服务费',
                        field: 'fi__lendingFee',


                    },
                    {
                        label: '利息收取节点',
                        field: 'fi__interestPayTime',

                    },
                    {
                        label: '费用收取节点',
                        field: 'fi__lendingFeePayTime',
                    },
                    {
                        label: '还款方式',
                        field: 'fi__repaymentFormula',
                        formatter: function (c,v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '还款期数（月）',
                        field: 'fi__repaymentCount',

                    },
                    {
                        label: '贷款用途',
                        field: 'ex__purpose',

                        span:24
                    },
                    {
                        label: '收款账号',
                        field: 'cb__accountNo',

                    },
                    {
                        label: '户名',
                        field: 'cb__accountName',

                    },
                    {
                        label: '开户行',
                        field: 'cb__bank',
                        span:24
                    },

                ],
                houseColumns:[
                    {
                        label: '权属',
                        field: 'pr__propertyOwner',

                    },
                    {
                        label: '位置',
                        field: 'pr__propertyLocation',

                    },
                    {
                        label: '用途',
                        field: 'pr__propertyUsage',

                    },
                    {
                        label: '面积',
                        field: 'pr__propertyArea',
                        unit:'㎡'
                    },
                    {
                        label: '产权证号',
                        field: 'pr__propertyCertNo',

                    },
                    {
                        label: '土地证',
                        field: 'pr__propertyLandNo',

                    },
                    {
                        label: '土地使用权面积',
                        field: 'pr__propertyLandArea',
                        unit:'㎡',
                        span:12

                    },


                    {
                        label: '担保合同编号',
                        field: 'doc__warrantNo',

                    },
                    {
                        label: '债权最高本金余额',
                        field: 'asm__nominalTotalValue',
                        formatter: function (c,v) {
                            return formatMoney(Math.floor((v-c.asm__pledgeRightsAmount)/10000)*10000,0)
                        },
                        unit:'元',

                    },
                    {
                        label: '暂作价',
                        field: 'asm__nominalTotalValue',
                        formatter: function (c,v) {
                            return formatMoney(Math.floor(v/10000)*10000,0)
                        },
                        unit:'元',

                    },
                    {
                        label: '抵押期限',
                        field: 'doc__pledgeFr',
                        formatter: function (c,v) {
                            if(v){
                                return moment(v).format('YYYY-MM-DD')+"至"+moment(c.doc__pledgeTo).format('YYYY-MM-DD')
                            }else{
                                return ''
                            }

                        },
                        span:24
                    },
                    {
                        label: '备注',
                        field: 'doc__remarks',
                        span:24

                    },

                ],
                planData:[],
                columns:[
                    {
                        label: '期数',
                        field: 'plan__sequenceNo'
                    },
                    {
                        label: '还款日期',
                        field: 'plan__repayDate'
                    },
                    {
                        label: '本金',
                        field: 'plan__principalAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '利息',
                        field: 'plan__interestAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    /* {
                    label: '服务费',
                    field: 'plan__lendingFeeAmount',
                    formatter: function (r,c,v) {
                    return formatMoney(v)+'元'
                    }
                    },*/
                    {
                        label: '其他费用',
                        field: 'plan__otherAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '合计',
                        field: 'plan__repayAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '剩余本金',
                        field: 'plan__principalBalance',
                        formatter: function (r,c,v) {
                            return formatMoney( (Number(v)||0) - (Number(r.plan__principalAmount)||0) ) + '元'
                        }
                    },
                    {
                        label: '还款状态',
                        field: 'plan__repaymentStatus',
                        formatter: function (r,c,v) {
                            return Status2CN(v)
                        }
                    },
                ],
                RepayColumns:[
                    {
                        label:'是否代偿',
                        field:'re__sequenceNo',
                        component:(r,c,v)=> {
                            let html = ``
                            if(r.dr__repayDate){
                                html = `<div  @click="showdialog('`+ this.transactionId+`','`+ r.re__sequenceNo +`')"><button class="classDy">已代偿</button></div>`
                            }
                            let showdialog = this.showdialog

                            return {
                                template: html,
                                methods: {
                                    showdialog,
                                }
                            }
                        },
                    },
                    {
                        label:'期数',
                        field:'re__sequenceNo',
                    },


                    {
                        label: '应还款日',
                        field: 'plan__repayDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '实还款日',
                        field: 're__repayDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '到账金额',
                        field: 're__repayAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '实还本金',
                        field: 're__principalAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '实还利息',
                        field: 're__interestAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '实还罚息',
                        field: 're__overdueFine',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '实还复利',
                        field: 're__compoundInterest',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    /*{
                    label: '提前还款违约金',
                    field: 're__penaltyAmount',
                    formatter: function (r,c,v) {
                    return formatMoney(v)+'元'
                    }
                    },*/
// {
//   label: '服务费',
//   field: 're__lendingFeeAmount',
//   formatter: function (r,c,v) {
//     return formatMoney(v)+'元'
//   }
// },
                    /* {
                    label: '其他费用',
                    field: 're__otherAmount',
                    formatter: function (r,c,v) {
                    return formatMoney(v)+'元'
                    }
                    },*/
                    {
                        label: '减免金额',
                        field: 're__deductionAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '上期余额',
                        field: 're__exBalanceAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '本期余额',
                        field: 're__excessAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },


                ],
                bankData: {
                    count: 0,
                    data: []
                },
                dialogVisible:false,
                actions: [

                    {
                        label: '导出客户还款明细',
                        clickHandler:()=>{
                            let routeData = this.$router.resolve({
                                path: '/ix/fang/financing/reporting/RepaymentByDealer.List?format=xls',
                                query: Object.assign(
                                    {
                                        'fi.transactionId':this.transactionId,
                                        pageSize:0
                                    },
                                    {}, {})
                            });
                            window.open(routeData.href.replace('#/', '/'), '_blank');
                        }
                    }
                ],
            }
        },
        computed:{
            fileList: {
                get() {
                    return this.financingDetail.files
                },
                set(newVal) {
                    this.financingDetail.files = newVal.map(item => Object.assign(item, {
                            'pa__fileId': item.fileId,
                            'pa__checked': true
                        })
                    )
                }
            },
            watchChecked() {
                return this.repayPlanList.map(item=>({
                    rex__waiveCompoundInterest: item.rex__waiveCompoundInterest,
                    rex__waiveOverdueFine: item.rex__waiveOverdueFine
                }))
            },
            freeAmount() {
                return (this.repayPlanList.reduce( (total, item)=> {
                    total += item.rex__waiveCompoundInterest == 'Y' ? item.rex__expectedCompoundInterest : 0
                    total += item.rex__waiveOverdueFine == 'Y'? item.rex__expectedOverdueFine : 0

                    return total;
                }, 0)).toFixed(2)
            },
           /* expectedTotalAmounts() {
                return (this.repayPlanList.reduce( (total, item)=> {
                    total += item.expectedTotalAmount


                    return total;
                }, 0)).toFixed(2)
            },*/
            watchLastOverdueDays() {
                return (this.repayPlanList[this.repayPlanList.length -1]||{}).rex__extendingDays||0
            }
        },
        watch:{
            'financingDetail.p__productId':function (newVal) {
                let lendingFee = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).p__lendingFee
                let interestRate = (this.productOptions.filter(item => item.value == newVal)[0]||{}).p__interestRate
                let lendingFeeType = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).p__lendingFeeType
                let interestType = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).p__interestType
// if(lendingFeeType=='Rate'){
//   if(this.financingDetail.fi__totalAmount){
//     this.financingDetail.fi__lendingFee = this.financingDetail.fi__totalAmount * interestRate/100
//   }
// }else{
//   this.financingDetail.fi__lendingFee = lendingFee
// }
//this.financingDetail.fi__interestType = interestType

            },
            'financingDetail.fi__totalAmount':function (newVal) {
                if(this.financingDetail.p__productId) {
                    let lendingFee = (this.productOptions.filter(item => item.value == this.financingDetail.p__productId)[0]||{}).p__lendingFee
                    let interestRate = (this.productOptions.filter(item => item.value == this.financingDetail.p__productId)[0]||{}).p__interestRate
                    let lendingFeeType = (this.productOptions.filter(item => item.value == this.financingDetail.p__productId)[0]||{}).p__lendingFeeType
                    let interestType  = (this.productOptions.filter(item => item.value == this.financingDetail.p__productId)[0]||{}).p__interestType
// if (lendingFeeType == 'Rate') {
//   if (this.financingDetail.fi__totalAmount) {
//     this.financingDetail.fi__lendingFee = this.financingDetail.fi__totalAmount * interestRate / 100
//   }
// } else {
//   this.financingDetail.fi__lendingFee = lendingFee
// }
//this.financingDetail.fi__interestType = interestType
                }
            },
            watchChecked: function () {
                this.calculateDetail()
            },
            watchLastOverdueDays: function (newVal, oldVal) {
                this.calculateDetail()
            }
        },
        filters: {

            Status2CN
        },
        mounted() {
            this.data()
            this.getbankData()
            this.getData()
            this.getFinanceProductFangList()

        },
        created() {
            this.calculateDetail()
        },
        methods:{
            showdialog:function(transactionId,sequenceNo){
                this.dialogVisible = true

                xhr.getRepaymentByCustomerList(
                    Object.assign({
                        'fi.transactionId':transactionId,
                      /*  'xlist.search.dr.sequenceNo':sequenceNo,
                        'xlist.search.dr.sequenceNo.op':'eq',
                        'xlist.search.dr.sequenceNo.numberformat':'int',*/
                        pageSize:0
                    }, {}, {}),
                    res=> {
                        try {
                            this.tableDataDetail = res.data
                            let balanceAmounts = 0
                            this.tableDataDetail.data.forEach(item=>{
                                balanceAmounts = balanceAmounts + parseFloat(item.cl__clearAmount)*10000
                            })

                            this.tableDataDetail.data.push({
                                cl__index:'合计',
                                dr__sequenceNo:'',
                                cl__clearDate:'',
                                cl__clearAmount:(balanceAmounts/10000).toFixed(2)||''
                            })
                        }catch(e){

                        }
                    })

            },

            getYongkuanData: function (transactionId) {
                xhr.getFinancingPaymentForApprovalList(
                    Object.assign({}, {}, {

                        'xlist.search.pay.applicationStatus' : 'Pending Approval,Completed,Approved',
                        'xlist.search.pay.applicationStatus.op' : 'in',
                        'xlist.search.fi.transactionId' : transactionId,
                        'xlist.search.fi.transactionId.op' : 'eq',
                    }),
                    res => {
                        try {
                            this.listData = res.data
                            if(this.listData.count==1){
                                this.applicationId = this.listData.data[0].pay__applicationId
                            }
                        } catch (e) {

                        }
                    })
            },
            getbankData:function(){
                xhr.getFinancingBankAccount({
                    'fi.transactionId': this.$route.query['transactionId']
                }, res => {
                    this.bankData = res.data
                })
            },
            data : function () {
                xhr.getFinancingFang({
                    'fi.transactionId': this.$route.query['transactionId']
                }, res=>{
                    try{
                        if(res.data.status == 'success') {
                            this.financingDetail = res.data.data
                            this.getYongkuanData(this.$route.query['transactionId'])
                            this.financingDetail.properties.forEach(item=>{
                                item.pr__propertyOwner =""
                                item.pr__owners.forEach(itemP=>{
                                    item.pr__propertyOwner = item.pr__propertyOwner+","+itemP.ow__ownerName
                                })
                                item.pr__propertyOwner = item.pr__propertyOwner.substr(1);
                            })
                            this.financingDetail.dfi__equitySwap = JSON.parse(this.financingDetail.dfi__equitySwap)
                            console.log(this.financingDetail.dfi__equitySwap)
                            /*let interestType =  this.customerDetail.ba__interestType
                            let unit = ''
                            this.customerDetail.interestType
                            if(interestType=='Yearly'){
                            unit="%（年利率）dfi__equitySwap
                            }
                            if(interestType=='Daily'){
                            unit="%（日利率）"
                            }
                            if(interestType=='Monthly'){
                            unit="%（月利率）"
                            }
                            this.customerDetail.interestType = this.customerDetail.ba__interestRate + unit*/

                        }
                    }catch(e){}
                })

            },
            getData:function(){
                xhr.getRepayPlanAll({
                    'fi.transactionId': this.$route.query['transactionId']
                }, res => {
                    this.planData = res.data.data.plans || []
//console.log(this.planData)
                })
            },

            getFinanceProductFangList: function () {
                xhr.getFinanceProductFangList(
                    Object.assign({}, {}, {}),
                    res=> {
                        try {
                            console.log( res.data.data)
                            this.productOptions = res.data.data.map(item=>{
                                return {
                                    label: item.p__productName,
                                    value:item.p__productId,
                                    'p__lendingFee':item.p__lendingFee,
                                    'p__lendingFeeType':item.p__lendingFeeType,
                                    'p__interestRate':item.p__interestRate,
                                    'p__interestType':item.p__interestType,
                                }

                            })
                            this.financingColumns[5].options = this.productOptions
// console.log( this.productOptions  )
                        }catch(e){

                        }
                    })

            },
            viewRepayPlay: function () {
                this.repaymentDialogVisible = true
            },
            jinjian: function () {
                this.jinjianDialogVisible = true
            },
            yongkuan: function () {
                this.yongkuanDialogVisible = true
            },
            shisuan: function () {
                this.shisuanDialogVisible = true
            },
            shisuan2: function () {
                if(!this.financingDetail.t__repayDate){
                    this.$alert('还款日期必填')
                    return false
                }
                xhr.shisuan2(
                    {
                        'fi.transactionId':this.financingDetail.fi__transactionId,
                        't.repayDate':this.financingDetail.t__repayDate,
                        't.repayDate.dateformat':'yyyy-MM-dd',
                        't.totalAmount':1,
                    },
                    res => {
                        try {
                            this.transferRepaymentDetail = res.data.data
                            res.data.data.detail.forEach(item=> {
                                item.expectedTotalAmount = 0
                            })
                            this.repayPlanList = (res.data.data.detail||[]).filter(item=>item.rex__expectedRepayDate)
                            if(this.repayPlanList.length==0){
                                 this.$alert(' 本期还款已还清或您暂无待还款！')
                            }
                        } catch (e) {

                        }
                    })
            },
            onSubmit :function (status) {
                this.approveDetail.fi__transactionId = this.transactionId
                this.approveDetail.a__approvingStatus = status
                xhr.updateApproveFinancing(
                    this.approveDetail,
                    res=> {
                        try{
                            if(res.data.status == 'success') {

                            }else{

                                this.$message.error(res.data.msgs[0].text)
                            }
                            this.$router.push({
                                path: 'List'
                            })
                        }catch (e) {

                            this.$message.error(error.msgs[0].text)

                        }
                    }
                )
            },
            calculateDetail() {
                this.expectedTotalAmounts = 0
                let balanceAmount = Number(this.transferRepaymentDetail.t__totalAmount)

                if( this.repayPlanList.length>0)
                    balanceAmount = Number(balanceAmount+this.repayPlanList[0].rex__exBalanceAmount)||0

                this.repayPlanList.forEach((item,idx)=> {

                    idx > 0 && (item.rex__exBalanceAmount = this.repayPlanList[idx-1].rex__excessAmount)

                    item.rex__appliedCompoundInterest = item.rex__waiveCompoundInterest == 'Y' ? 0 : ( balanceAmount > item.rex__expectedCompoundInterest ? item.rex__expectedCompoundInterest :  balanceAmount  )
                    balanceAmount = Number((balanceAmount - item.rex__appliedCompoundInterest).toFixed(2))

                    item.rex__appliedOverdueFine = item.rex__waiveOverdueFine == 'Y'? 0 : ( balanceAmount > item.rex__expectedOverdueFine ? item.rex__expectedOverdueFine :  balanceAmount )
                    balanceAmount = Number((balanceAmount - item.rex__appliedOverdueFine).toFixed(2))


                    let interestRate = this.financingDetail.fi__interestRate
                    let interestType = this.financingDetail.fi__interestType

                    let extendingInterestAmount = 0

                    if (item.rex__extendible == 'Y') {
                        if (item.rex__extendingDays) {
                            if (interestType == 'Yearly') {
                                extendingInterestAmount = (item.rex__extendingDays * interestRate / 36000) * item.rex__expectedPrincipalAmount
                            }
                            if (interestType == 'Monthly') {
                                extendingInterestAmount = (item.rex__extendingDays * interestRate / 3000) * item.rex__expectedPrincipalAmount
                            }
                            if (interestType == 'Daily') {
                                extendingInterestAmount = (item.rex__extendingDays * inYterestRate / 100) * item.rex__expectedPrincipalAmount
                            }

                        }
                    }
                    item.rex__extendingInterestAmount = extendingInterestAmount.toFixed(2)
                    // item.rex__appliedInterestAmount = balanceAmount > item.rex__expectedInterestAmount ? item.rex__expectedInterestAmount : balanceAmount


                    if(item.rex__extendible=='M'){

                    }else{
                        let appliedInterestAmount = ((Number(item.rex__expectedInterestAmount)||0)+ (Number(item.rex__extendingInterestAmount)||0))
                       /* console.log('*****')
                        console.log(balanceAmount)
                        console.log(appliedInterestAmount)*/
                        item.rex__appliedInterestAmount = ( balanceAmount > appliedInterestAmount ? appliedInterestAmount : balanceAmount ).toFixed(2)
                    }

                    /* console.log(balanceAmount)
                     console.log(item.rex__expectedPrincipalAmount)
                     console.log(item.rex__extendingInterestAmount)*/



                    balanceAmount = Number((balanceAmount - item.rex__appliedInterestAmount).toFixed(2))


                    item.rex__appliedPrincipalAmount = balanceAmount > item.rex__expectedPrincipalAmount ? item.rex__expectedPrincipalAmount : balanceAmount
                    balanceAmount = Number((balanceAmount - item.rex__appliedPrincipalAmount).toFixed(2))

                    item.expectedTotalAmount = Number(( (item.rex__waiveCompoundInterest== 'Y' ? 0 : item.rex__expectedCompoundInterest) +  (item.rex__waiveOverdueFine== 'Y' ? 0 : item.rex__expectedOverdueFine) + item.rex__expectedInterestAmount + item.rex__expectedPrincipalAmount).toFixed(2))
                    if(item.rex__extendible=='Y'){
                        item.expectedTotalAmount = Number(item.expectedTotalAmount) +(Number(item.rex__extendingInterestAmount)||0)
                    }
                    console.log(item.expectedTotalAmount)
                    this.expectedTotalAmounts += item.expectedTotalAmount
                    item.needAmount = Number((item.expectedTotalAmount - item.rex__appliedCompoundInterest -item.rex__appliedOverdueFine-item.rex__appliedInterestAmount-item.rex__appliedPrincipalAmount).toFixed(2))

                    item.rex__excessAmount = balanceAmount
                })
                this.expectedTotalAmounts =  this.expectedTotalAmounts.toFixed(2)
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerFinancingDetail.vue